import fp from 'lodash/fp';
import { createSelector } from 'reselect';

export const getInventoryDonorSummaryReport = fp.get(
  'inventory.reports.donorSummary'
);

export const getAll = createSelector(
  getInventoryDonorSummaryReport,
  fp.get('all')
);

export const getIsFetching = createSelector(
  getInventoryDonorSummaryReport,
  fp.get('fetching')
);
export const getIsFetched = createSelector(
  getInventoryDonorSummaryReport,
  fp.get('fetched')
);
export const getFetchingError = createSelector(
  getInventoryDonorSummaryReport,
  fp.get('fetchingError')
);
